import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./retirementTimeline.scss";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";

const RetirementTimelineModal = (props) => {
  const [currentSection, setCurrentSection] = useState("firstSection");

  const handleNextClick = () => {
    setCurrentSection("secondSection");
  };

  const handlePrevClick = () => {
    setCurrentSection("firstSection");
  };

  const handleGotItClick = (e) => {
    if (e !== undefined) {
      e.preventDefault();
    }
    props.handleCloseButton();
  };

  return (
    <div className="retirement-timeline-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">{props.headTitle}</div>
      <div className="sub-text card-carousel">
        {currentSection === "firstSection" && (
          <div className={props.firstSection}>
            <Row className="card-row">
              <Col md={12}>
                <Row>
                  <Col md={8}>
                    <h3 className="subHeading mb-4">1. What happens next?</h3>
                  </Col>
                </Row>
                <p>
                  We’ll get started straight away to process your application,
                  verify your details and get your money to you. You’ll receive
                  an email notification when your money is on its way to you.
                </p>
                <p>
                  If you have already stopped contributions, lump sums can be
                  usually be paid within two weeks, but read on for more
                  details.
                </p>
                <p>
                  Regular income payments are made on 5th monthly, applications
                  prior to 8th will receive their first income on 5th of the
                  following month. For example, applications for regular income
                  received on 14th of June would receive their first income on 5
                  August.
                </p>
              </Col>
            </Row>
            <div className="btnSection mt-5">
              <Buttons
                className="primary"
                name={props.btnNext}
                handleClick={handleNextClick}
              />
            </div>
          </div>
        )}
        {currentSection === "secondSection" && (
          <div className={props.secondSection}>
            <Row className="card-row">
              <Col md={12}>
                <Row>
                  <Col md={8}>
                    <h3 className="subHeading mb-4">2. How you can help</h3>
                  </Col>
                </Row>
                <ul>
                  <li>
                    Please respond swiftly if we ask for any further information
                  </li>
                  <li>
                    If you’re stopping contributions, make sure you’ve informed
                    your employer as we’ll need your leaving date from your
                    employer and your final contributions before processing your
                    application (which can be a few weeks after the final month
                    of contribution).
                  </li>
                  <li>
                    Please ensure we have full payment instructions from your
                    annuity provider so we can process your application.
                    Tax-free cash and the annuity would be paid at the same
                    time.
                  </li>
                  <li>
                    Please don’t make any financial commitments until you’ve
                    received your pension.
                  </li>
                </ul>
              </Col>
            </Row>
            <div className="btnSection d-flex justify-content-between mt-5">
              <Buttons
                className="primary"
                name={props.btnPre}
                handleClick={handlePrevClick}
              />
              <Buttons
                className="primary"
                name={props.btnGotit}
                handleClick={handleGotItClick}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RetirementTimelineModal;
